import { useCreateTermineFormContext } from '@/domain/termine/features/CreateTermin/shared/useCreateTermineFormContext';
import { useTranslation } from 'react-i18next';

export function TextAreaFormField({
  name,
}: {
  name: 'beschreibung' | 'specials';
}) {
  const { t } = useTranslation();
  const { form } = useCreateTermineFormContext();

  return (
    <form.AppField name={name}>
      {(field) => (
        <field.TextArea
          label={
            name === 'beschreibung'
              ? t('domain.termine.description')
              : t('domain.termine.additionalInformation')
          }
        />
      )}
    </form.AppField>
  );
}
